// Author: Shubham Srivastava
// Env File to use for Production.

export const environment = {
  production: true,
  configType: false,
  apiBaseUrl:'https://theworldwidecard.net/v2',
  loginAPIUrl: 'https://theworldwidecard.net/api/v1.0',
  apiBaseUrl2:'https://xabits.com/app',
  apiBaseUrl3:'https://theworldwidecard.net',
  pgAPIUrl:'https://pgs-reporting.herokuapp.com/api',
  pgUrlNew:'https://pgs-reporting.herokuapp.com',
  pgAPIUrl1:'https://pgs-reporting-webhook.herokuapp.com/api',
  pgUrlNew1:'https://pgs-reporting-webhook.herokuapp.com',
  setHeaderToken:true
};
